import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import SerahTerimaOperasiSvc from "@/services/SerahTerimaOperasi";

@Module({ store, dynamic: true, namespaced: true, name: "serah-terima-operasi" })
class SerahTerimaOperasiModule extends VuexModule {
  items: any[] = [];
  loading = false;

  @Mutation SET_ITEMS(val: any[]) {
    this.items = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async fetchByRegister(reg: string | number) {
    this.SET_LOADING(true);

    try {
      const dt = await SerahTerimaOperasiSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_ITEMS(data || []);
    } catch {
      this.SET_ITEMS([]);
    }

    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_ITEMS([]);
  }
}

export const storeSerahTerimaOperasi = getModule(SerahTerimaOperasiModule);
